<div class="content-pool-status-container content-pools-group">
    @if (activePools.length > 0) {
    <div class="status-section">
      <div class="status-label">Active Content Pools</div>
      <div class="pools-display">
        @for (pool of getDisplayPools(activePools); track trackByPoolId($index, pool)) {
        <div class="pool-chip status-active" [title]="pool.name">
          {{ pool.name }}
        </div>
        }
        @if (getRemainingCount(activePools) > 0) {
        <div class="overflow-indicator status-active">
          +{{ getRemainingCount(activePools) }}
          <div class="tooltip-list">
            <span class="tooltip-title">More Active</span>
            @for (pool of activePools.slice(maxDisplayItems); track pool.id; let last = $last) {
            <span class="tooltip-item">{{ pool.name }}@if (!last) {, }</span>
            }
          </div>
        </div>
        }
      </div>
    </div>
    }

    @if (pendingPools.length > 0) {
    <div class="status-section">
      <div class="status-label">Pending Content Pools</div>
      <div class="pools-display">
        @for (pool of getDisplayPools(pendingPools); track trackByPoolId($index, pool)) {
        <div class="pool-chip status-pending" [title]="pool.name">
          {{ pool.name }}
        </div>
        }
        @if (getRemainingCount(pendingPools) > 0) {
        <div class="overflow-indicator status-pending">
          +{{ getRemainingCount(pendingPools) }}
          <div class="tooltip-list">
            <span class="tooltip-title">More Pending</span>
            @for (pool of pendingPools.slice(maxDisplayItems); track pool.id; let last = $last) {
            <span class="tooltip-item">{{ pool.name }}@if (!last) {, }</span>
            }
          </div>
        </div>
        }
      </div>
    </div>
    }

    @if (deletedPools.length > 0) {
    <div class="status-section">
      <div class="status-label">Deleted Content Pools</div>
      <div class="pools-display">
        @for (pool of getDisplayPools(deletedPools); track trackByPoolId($index, pool)) {
        <div class="pool-chip status-deleted" [title]="pool.name">
          {{ pool.name }}
        </div>
        }
        @if (getRemainingCount(deletedPools) > 0) {
        <div class="overflow-indicator status-deleted">
          +{{ getRemainingCount(deletedPools) }}
          <div class="tooltip-list">
            <span class="tooltip-title">More Deleted</span>
            @for (pool of deletedPools.slice(maxDisplayItems); track pool.id) {
            <span class="tooltip-item">{{ pool.name }}</span>
            }
          </div>
        </div>
        }
      </div>
    </div>
    }
    @if (contentPools.length === 0) {
    <div class="no-pools-message">
      <span class="no-pools-text">No content pools assigned to this segment</span>
    </div>
    }
  </div>


@if (activeTTDSegment.length > 0 || pendingTTDSegment.length > 0 || deletedTTDSegment.length > 0) {
  <div class="content-pool-status-container ttd-segment-ids-group">
      @if (activeTTDSegment.length > 0) {
      <div class="status-section">
        <div class="status-label">Active TTD Segment</div>
        <div class="pools-display">
          @for (pid of getDisplayIds(activeTTDSegment); track pid; let last = $last) {
          <div class="pool-chip id-chip status-active" [title]="pid">
            {{ pid }}
          </div>
          }
          @if (getRemainingCountForIds(activeTTDSegment) > 0) {
          <div class="overflow-indicator status-active">
            +{{ getRemainingCountForIds(activeTTDSegment) }}
            <div class="tooltip-list">
              <span class="tooltip-title">More Active TTD Segments</span>
              @for (pid of activeTTDSegment.slice(maxDisplayItems); track pid; let last = $last) {
              <span class="tooltip-item">{{ pid }}@if (!last) {, }</span>
              }
            </div>
          </div>
          }
        </div>
      </div>
      }
  
      @if (pendingTTDSegment.length > 0) {
      <div class="status-section">
        <div class="status-label">Pending TTD Segments</div>
        <div class="pools-display">
          @for (pid of getDisplayIds(pendingTTDSegment); track pid; let last = $last) {
          <div class="pool-chip id-chip status-pending" [title]="pid">
            {{ pid }}
          </div>
          }
          @if (getRemainingCountForIds(pendingTTDSegment) > 0) {
          <div class="overflow-indicator status-pending">
            +{{ getRemainingCountForIds(pendingTTDSegment) }}
            <div class="tooltip-list">
              <span class="tooltip-title">More Pending TTD Segments</span>
              @for (pid of pendingTTDSegment.slice(maxDisplayItems); track pid; let last = $last) {
              <span class="tooltip-item">{{ pid }}@if (!last) {, }</span>
              }
            </div>
          </div>
          }
        </div>
      </div>
      }
  
      @if (deletedTTDSegment.length > 0) {
      <div class="status-section">
        <div class="status-label">Deleted TTD Segments</div>
        <div class="pools-display">
          @for (pid of getDisplayIds(deletedTTDSegment); track pid) {
          <div class="pool-chip id-chip status-deleted" [title]="pid">
            {{ pid }}
          </div>
          }
          @if (getRemainingCountForIds(deletedTTDSegment) > 0) {
          <div class="overflow-indicator status-deleted">
            +{{ getRemainingCountForIds(deletedTTDSegment) }}
            <div class="tooltip-list">
              <span class="tooltip-title">More Deleted TTD Segments</span>
              @for (pid of deletedTTDSegment.slice(maxDisplayItems); track pid) {
              <span class="tooltip-item">{{ pid }}</span>
              }
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>
  }

@if (activePartnerIds.length > 0 || pendingPartnerIds.length > 0 || deletedPartnerIds.length > 0) {
<div class="content-pool-status-container partner-ids-group">
    @if (activePartnerIds.length > 0) {
    <div class="status-section">
      <div class="status-label">Active Partner IDs</div>
      <div class="pools-display">
        @for (pid of getDisplayIds(activePartnerIds); track pid; let last = $last) {
        <div class="pool-chip id-chip status-active" [title]="pid">
          {{ pid }}
        </div>
        }
        @if (getRemainingCountForIds(activePartnerIds) > 0) {
        <div class="overflow-indicator status-active">
          +{{ getRemainingCountForIds(activePartnerIds) }}
          <div class="tooltip-list">
            <span class="tooltip-title">More Active Partner IDs</span>
            @for (pid of activePartnerIds.slice(maxDisplayItems); track pid; let last = $last) {
            <span class="tooltip-item">{{ pid }}@if (!last) {, }</span>
            }
          </div>
        </div>
        }
      </div>
    </div>
    }

    @if (pendingPartnerIds.length > 0) {
    <div class="status-section">
      <div class="status-label">Pending Partner IDs</div>
      <div class="pools-display">
        @for (pid of getDisplayIds(pendingPartnerIds); track pid; let last = $last) {
        <div class="pool-chip id-chip status-pending" [title]="pid">
          {{ pid }}
        </div>
        }
        @if (getRemainingCountForIds(pendingPartnerIds) > 0) {
        <div class="overflow-indicator status-pending">
          +{{ getRemainingCountForIds(pendingPartnerIds) }}
          <div class="tooltip-list">
            <span class="tooltip-title">More Pending Partner IDs</span>
            @for (pid of pendingPartnerIds.slice(maxDisplayItems); track pid; let last = $last) {
            <span class="tooltip-item">{{ pid }}@if (!last) {, }</span>
            }
          </div>
        </div>
        }
      </div>
    </div>
    }

    @if (deletedPartnerIds.length > 0) {
    <div class="status-section">
      <div class="status-label">Deleted Partner IDs</div>
      <div class="pools-display">
        @for (pid of getDisplayIds(deletedPartnerIds); track pid) {
        <div class="pool-chip id-chip status-deleted" [title]="pid">
          {{ pid }}
        </div>
        }
        @if (getRemainingCountForIds(deletedPartnerIds) > 0) {
        <div class="overflow-indicator status-deleted">
          +{{ getRemainingCountForIds(deletedPartnerIds) }}
          <div class="tooltip-list">
            <span class="tooltip-title">More Deleted Partner IDs</span>
            @for (pid of deletedPartnerIds.slice(maxDisplayItems); track pid) {
            <span class="tooltip-item">{{ pid }}</span>
            }
          </div>
        </div>
        }
      </div>
    </div>
    }
  </div>
}

@if (activeAdvertiserIds.length > 0 || pendingAdvertiserIds.length > 0 || deletedAdvertiserIds.length > 0) {
  <div class="content-pool-status-container partner-ids-group">
      @if (activeAdvertiserIds.length > 0) {
      <div class="status-section">
        <div class="status-label">Active Advertiser IDs</div>
        <div class="pools-display">
          @for (pid of getDisplayIds(activeAdvertiserIds); track pid; let last = $last) {
          <div class="pool-chip id-chip status-active" [title]="pid">
            {{ pid }}
          </div>
          }
          @if (getRemainingCountForIds(activeAdvertiserIds) > 0) {
          <div class="overflow-indicator status-active">
            +{{ getRemainingCountForIds(activeAdvertiserIds) }}
            <div class="tooltip-list">
              <span class="tooltip-title">More Active Advertiser IDs</span>
              @for (pid of activeAdvertiserIds.slice(maxDisplayItems); track pid; let last = $last) {
              <span class="tooltip-item">{{ pid }}@if (!last) {, }</span>
              }
            </div>
          </div>
          }
        </div>
      </div>
      }
  
      @if (pendingAdvertiserIds.length > 0) {
      <div class="status-section">
        <div class="status-label">Pending Advertiser IDs</div>
        <div class="pools-display">
          @for (pid of getDisplayIds(pendingAdvertiserIds); track pid; let last = $last) {
          <div class="pool-chip id-chip status-pending" [title]="pid">
            {{ pid }}
          </div>
          }
          @if (getRemainingCountForIds(pendingAdvertiserIds) > 0) {
          <div class="overflow-indicator status-pending">
            +{{ getRemainingCountForIds(pendingAdvertiserIds) }}
            <div class="tooltip-list">
              <span class="tooltip-title">More Pending Advertiser IDs</span>
              @for (pid of pendingAdvertiserIds.slice(maxDisplayItems); track pid; let last = $last) {
              <span class="tooltip-item">{{ pid }}@if (!last) {, }</span>
              }
            </div>
          </div>
          }
        </div>
      </div>
      }
  
      @if (deletedAdvertiserIds.length > 0) {
      <div class="status-section">
        <div class="status-label">Deleted Advertiser IDs</div>
        <div class="pools-display">
          @for (pid of getDisplayIds(deletedAdvertiserIds); track pid) {
          <div class="pool-chip id-chip status-deleted" [title]="pid">
            {{ pid }}
          </div>
          }
          @if (getRemainingCountForIds(deletedAdvertiserIds) > 0) {
          <div class="overflow-indicator status-deleted">
            +{{ getRemainingCountForIds(deletedAdvertiserIds) }}
            <div class="tooltip-list">
              <span class="tooltip-title">More Deleted Advertiser IDs</span>
              @for (pid of deletedAdvertiserIds.slice(maxDisplayItems); track pid) {
              <span class="tooltip-item">{{ pid }}</span>
              }
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>
  }

@if (activeParentElementIds.length > 0 || pendingParentElementIds.length > 0 || deletedParentElementIds.length > 0) {
<div class="content-pool-status-container provider-element-ids-group">
    @if (activeParentElementIds.length > 0) {
    <div class="status-section">
      <div class="status-label">Active Provider Element IDs</div>
      <div class="pools-display">
        @for (peid of getDisplayIds(activeParentElementIds); track peid; let last = $last) {
        <div class="pool-chip id-chip status-active" [title]="peid">
          {{ peid }}
        </div>
        }
        @if (getRemainingCountForIds(activeParentElementIds) > 0) {
        <div class="overflow-indicator status-active">
          +{{ getRemainingCountForIds(activeParentElementIds) }}
          <div class="tooltip-list">
            <span class="tooltip-title">More Active Provider Element IDs</span>
            @for (peid of activeParentElementIds.slice(maxDisplayItems); track peid; let last = $last) {
            <span class="tooltip-item">{{ peid }}@if (!last) {, }</span>
            }
          </div>
        </div>
        }
      </div>
    </div>
    }

    @if (pendingParentElementIds.length > 0) {
    <div class="status-section">
      <div class="status-label">Pending Provider Element IDs</div>
      <div class="pools-display">
        @for (peid of getDisplayIds(pendingParentElementIds); track peid; let last = $last) {
        <div class="pool-chip id-chip status-pending" [title]="peid">
          {{ peid }}
        </div>
        }
        @if (getRemainingCountForIds(pendingParentElementIds) > 0) {
        <div class="overflow-indicator status-pending">
          +{{ getRemainingCountForIds(pendingParentElementIds) }}
          <div class="tooltip-list">
            <span class="tooltip-title">More Pending Provider Element IDs</span>
            @for (peid of pendingParentElementIds.slice(maxDisplayItems); track peid; let last = $last) {
            <span class="tooltip-item">{{ peid }}@if (!last) {, }</span>
            }
          </div>
        </div>
        }
      </div>
    </div>
    }

    @if (deletedParentElementIds.length > 0) {
    <div class="status-section">
      <div class="status-label">Deleted Provider Element IDs</div>
      <div class="pools-display">
        @for (peid of getDisplayIds(deletedParentElementIds); track peid) {
        <div class="pool-chip id-chip status-deleted" [title]="peid">
          {{ peid }}
        </div>
        }
        @if (getRemainingCountForIds(deletedParentElementIds) > 0) {
        <div class="overflow-indicator status-deleted">
          +{{ getRemainingCountForIds(deletedParentElementIds) }}
          <div class="tooltip-list">
            <span class="tooltip-title">More Deleted Provider Element IDs</span>
            @for (peid of deletedParentElementIds.slice(maxDisplayItems); track peid) {
            <span class="tooltip-item">{{ peid }}</span>
            }
          </div>
        </div>
        }
      </div>
    </div>
    }
  </div>
}